module.exports = __webpack_public_path__ + "img/Fail.144d378a.png";